const STORAGE_KEY = 'seospider_ecwid_bulk_optimize_tour_done_v1';

export function hasCompletedBulkOptimizeTour() {
  if (typeof window === 'undefined') return true;
  try {
    return window.localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return true;
  }
}

export function markBulkOptimizeTourCompleted() {
  try {
    window.localStorage.setItem(STORAGE_KEY, '1');
  } catch {
    // ignore
  }
}
